export default {
  // namespaced: true,
  state: {
    warns: [
      // {id: 123, title: null, message: null, status: null}
    ]
  },
  mutations: {
    SET_WARN (store, data) {
      store.warns.push(data)
    },
    REMOVE_WARN (store, id) {
      const index = store.warns.findIndex(v => v.id === id)
      store.warns.splice(index, 1)
    }
  },
  getters: {
    getWarns: (store, getters) => {
      return store.warns
    }
  },
  actions: {
    /*
    setWarn
    */
    setWarn ({commit, dispatch, getters, state}, data) {
      const id = Math.random()
      commit('SET_WARN', {
        id: id,
        title: data.title || 'Concluído',
        message: data.message || 'A operação foi concluída',
        status: data.status
      })
      setTimeout(() => {
        commit('REMOVE_WARN', id)
      }, 5000)
      return data
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Warn.js